import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  margin: 40px 0 0 0;

  svg {
    width: 20px;
  }

  a {
    gap: 8px;
    padding: 8px 16px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.primaryColor || '#36397a'};
    text-decoration: none;

    :hover {
      background: ${props => darken(0.08, props.primaryColor || '#36397a')};
    }

    > span {
      > span {
        display: flex;
        gap: 8px;
      }
    }
  }
`;

export const ContainerText = styled.div`
  display: flex;
  max-width: 980px;
  align-items: center;
  gap: 40px;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  @media only screen and (max-width: 950px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const ContainerTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  @media only screen and (max-width: 950px) {
    align-items: center;
  }
`;

export const SubTitle = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #475467;
  text-align: left;
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #475467;
    text-align: center;
    white-space: break-spaces;
  }
`;

export const Title = styled.h4`
  /* width: 280px; */
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 50px;
  color: #475467;
  margin-bottom: 10px;
  text-transform: uppercase;
  text-align: left;
  @media only screen and (max-width: 950px) {
    width: auto;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: #475467;
    text-transform: uppercase;
    white-space: break-spaces;
    text-align: center;
  }
`;

export const Description = styled.span`
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
  text-align: left;
  color: #475467;
  white-space: pre-line;
  @media only screen and (max-width: 950px) {
    padding: 0 16px;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #475467;
  }
`;

export const ContainerImage = styled.div`
  width: 980px;
  margin-top: 44px;
  justify-content: center;
  gap: 44px;
  display: flex;
  flex-wrap: wrap;
  min-height: 478px;
  margin-bottom: 44px;

  img.img-about {
    border-radius: 8px !important;
    object-fit: contain !important;
  }

  @media only screen and (max-width: 950px) {
    display: none;
  }
`;

export const CarouselImage = styled.div`
  display: none;
  position: relative;
  width: 100%;
  div.container-slider-about {
    position: relative;
    transition: 0.6s;
    width: 100%;
    overflow: hidden;
    height: 320px;

    @media only screen and (max-width: 950px) {
      justify-content: center;
    }

    div.inner-slider-about {
      pointer-events: none;
      width: 100%;
      display: flex;
      gap: 44px;
      transition: 0.6s;
      position: absolute;
      left: 20px;
    }
  }

  @media only screen and (max-width: 950px) {
    padding: 0 16px;
    position: relative;
    margin-top: 44px;
    display: flex;
    flex-direction: column;

    img {
      height: 308px;
      width: 100%;
      border-radius: 8px;
      object-fit: contain;
      pointer-events: none;
    }
  }
`;

export const Row = styled.div`
  display: none;
  @media only screen and (max-width: 950px) {
    width: 100%;
    display: ${props => (props.hide ? 'none' : 'flex')};
    align-items: center;
    justify-content: center;

    svg {
      margin-left: 8px;
      width: 8px;
    }
  }
`;
